// src/utils/ebay/ebaySku.js
// Builds the SKU written to a listing's eBay "Custom label", which is how an
// imported order is matched back to its listing.

export const EBAY_SKU_PREFIX = 'PV';

// Crockford-style alphabet: no 0/1/I/O, so a SKU can be read aloud or retyped
// from Seller Hub without ambiguity.
const SUFFIX_ALPHABET = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
const SUFFIX_LENGTH = 4;
const SEQUENCE_PAD = 5;

const randomSuffix = () => {
  const bytes = new Uint8Array(SUFFIX_LENGTH);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => SUFFIX_ALPHABET[byte % SUFFIX_ALPHABET.length]).join('');
};

/**
 * Builds a SKU of the form PV-00187-4QX9.
 *
 * The sequence is a per-user counter and exists only to be readable and
 * sortable. The random suffix makes accidental collisions rare. Global
 * uniqueness is enforced by reserving the full string in `groupCodes`
 * at mint time. Matching always compares the full stored string, never
 * the sequence.
 *
 * @param {number} sequence - Per-user listing counter
 * @returns {string} SKU
 */
export function buildEbaySku(sequence) {
  const seq = String(Math.max(1, Number(sequence) || 1)).padStart(SEQUENCE_PAD, '0');
  return `${EBAY_SKU_PREFIX}-${seq}-${randomSuffix()}`;
}
